/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('AddPositionFotoCtrl',['$rootScope','$scope','MainService','NetworkService', function ($rootScope, $scope, MainService, NetworkService) {
    $scope.myImage = '';
    $scope.myCroppedImage = '';
    $scope.showImageEditWindow = false
    $rootScope.$on("setImage", function()
    {
        var pic = MainService.getProfilePic()
        $scope.myImage = pic
        $scope.showImageEditWindow = true
    })

    var handleFileSelect = function (evt) {
        $scope.showImageEditWindow = true
        var file = evt.currentTarget.files[0];
        var reader = new FileReader();
        reader.onload = function (evt) {
            $scope.$apply(function ($scope) {
                console.log(evt.target.result)
                $scope.myImage = evt.target.result;
            });
        };
        reader.readAsDataURL(file);
    };
    
    $scope.saveCroppedImage = function()
    {
        $scope.showImageEditWindow = false
        MainService.setProfilePic($scope.myCroppedImage)
    }
    
    angular.element(document.querySelector('#addPosBild')).on('change', handleFileSelect);
}]);